var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"error":_vm.name,"label":_vm.labelTxt}})}
var staticRenderFns = []

export { render, staticRenderFns }